import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Product, AddToCartEvent } from '../../../../../shared/models/product.model';
import { ProductCarouselComponent } from '../../../../home/blocks/product-carousel/product-carousel.component';

@Component({
  selector: 'app-related-products',
  imports: [ProductCarouselComponent],
  templateUrl: './related-products.component.html',
  styleUrl: './related-products.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedProductsComponent {
  products = input<Product[]>([]);
  title = input<string>('Productos relacionados');
  // CTA opcional al final del carrusel (ej.: "Ver más productos de Pokémon TCG").
  // Si cualquiera de los dos llega vacío, el slot final no se renderiza.
  trailingLabel = input<string>('');
  trailingLink = input<string>('');

  addToCart = output<AddToCartEvent>();
  zoomOpen = output<Product>();
  notifyRequest = output<Product>();
  /**
   * «Ya no me avises» de la card. La card deduce del `StockAlertStore` que el
   * usuario está suscrito, así que sin este output el botón se pintaba sin
   * destino.
   */
  notifyCancel = output<Product>();
  cardClick = output<Product>();
  /** Propagación del CTA "Reservar" de ProductCard hacia el padre. */
  reserveClick = output<Product>();
}
